<template>
    <div>
        <v-tabs v-model="tab" grow>
            <v-tab href="#main" value="main"> Edition </v-tab>
            <v-tab href="#scope" value="scope"> Périmètre </v-tab>
        </v-tabs>
        <v-tabs-window v-model="tab">
            <v-window-item value="main">
                <v-card flat>
                    <v-card-title>Parametrage</v-card-title>
                    <v-card-subtitle>Paramétrez votre extension</v-card-subtitle>
                    <v-card-text>
                        <v-form v-model="isValidForm">
                            <v-text-field-filled
                                label="Nom de l'extension"
                                v-model="nameSync"
                                outlined
                                :readonly="readonly"
                                :rules="[(v) => !!v || 'Le nom de l\'extension est requis']"
                                density="compact"
                                class="pb-4"
                            />
                            <v-text-field-filled
                                label="Url"
                                placeholder="https://"
                                v-model="urlSync"
                                outlined
                                :readonly="readonly"
                                :rules="[
                                    (v) => !!v || 'L\'url est requise',
                                    // (v) => (v && v.match(this.urlRegex)) || 'L\'url doit être valide',
                                ]"
                                density="compact"
                                class="pb-4"
                            />
                            <div class="d-flex">
                                <v-select-filled
                                    outlined
                                    class="mr-1"
                                    label="Type"
                                    v-model="typeSync"
                                    :items="extensionTypes"
                                    :readonly="readonly"
                                    :rules="[(v) => !!v || 'Le type est requise']"
                                    density="compact"
                                />
                                <v-select-filled
                                    outlined
                                    class="ml-1"
                                    label="Page d'affichage"
                                    v-model="displayInSync"
                                    :items="extensionDisplayIn"
                                    :readonly="readonly"
                                    :rules="[(v) => !!v || 'La page d\'affichage est requise']"
                                    density="compact"
                                />
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="scope">
                <ScopeManager
                    v-model="scopeSync"
                    v-model:id="scopeId"
                    v-model:name="scopeName"
                    :readonly="readonly"
                />
            </v-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts">
import ScopeManager from "../companyScope/ScopeManager.vue";
import UPSERT_EXTENSION from "@/graphql/extension/UpsertExtension.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

@Component({
    components: {
        ScopeManager,
    },
})
export class ExtensionItem extends Vue {
    // Extension Object

    @Model({ type: String, default: "", name: "name" }) nameSync!: string;

    @Model({ type: String, default: "", name: "url" }) urlSync!: string;

    @Model({ type: String, name: "id" }) idSync!: string;

    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    @Model({ type: String, name: "displayIn" }) displayInSync!: string;

    @Model({ type: String, name: "type" }) typeSync!: string;

    @Prop({ default: null }) actions: any;
    @Prop({ default: false }) readonly: boolean;

    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    scopeName_: string = "";

    get scopeName() {
        if (this.scopeSync?.name) {
            this.scopeName_ = this.scopeSync?.name;
        }
        return this.scopeName_;
    }

    set scopeName(value) {
        this.scopeName_ = value;
    }

    tab: "main" | "scope" = "main";

    scope = null;

    urlRegex: RegExp =
        /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/g;

    get extensionTypes() {
        return [
            {
                title: "Page",
                value: "FULL_PAGE",
            },
            {
                title: "Indicateur",
                value: "CARD",
            },
            {
                title: "Dialogue",
                value: "DIALOG",
            },
        ];
    }

    get isValidForm() {
        return !this.actions.action.disabled;
    }

    set isValidForm(value) {
        this.actions.action.disabled = !(value && !!this.scopeId);
    }

    get companyId() {
        debugger;
        return this.$store.state?.user?.company?.id;
    }

    get extensionDisplayIn() {
        return [
            {
                title: "Tableau des documents",
                value: "DOCUMENTS_TABLE",
            },
            {
                title: "Tableau de bord",
                value: "DASHBOARD",
            },
            {
                title: "Grand livre",
                value: "GENERAL_LEDGER",
            },
            {
                title: "Export",
                value: "EXPORT",
            },
        ];
    }

    beforeMount() {
        if (this.actions?.action) {
            this.actions.action.title = this.idSync ? "Modifier" : "Créer";
            this.actions.action.function = () => {
                this.upsertExtension();
            };
            this.actions.action.display = true;
            this.actions.action.disabled = true;
        }
    }

    @Emit("updated")
    async upsertExtension() {
        if (this.isValidForm) {
            const extension = await this.$apollo.mutate({
                mutation: UPSERT_EXTENSION,
                variables: {
                    id: this.idSync,
                    name: this.nameSync,
                    url: this.urlSync,
                    type: this.typeSync,
                    displayIn: this.displayInSync,
                    companyId: this.companyId,
                    companyScopeId: this.scopeId,
                },
            });

            if (extension?.data?.upsertExtension?.id) {
                this.idSync = extension.data.upsertExtension.id;
            }
        }
        return {
            id: this.idSync,
            name: this.nameSync,
            url: this.urlSync,
            type: this.typeSync,
            displayIn: this.displayInSync,
        };
    }
}

export default toNative(ExtensionItem);
</script>
